import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatIconModule, MatPaginatorModule,
	MatProgressSpinnerModule, MatSortModule, MatTableModule, } from '@angular/material';
import { CoreModule } from '../../../../core/core.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Datatable
import { DataTableComponent } from './general/data-table/data-table.component';
// General widgets
import { Widget1Component } from './widget1/widget1.component';
import { Widget4Component } from './widget4/widget4.component';
import { Widget5Component } from './widget5/widget5.component';
import { Widget14Component } from './widget14/widget14.component';
import { Widget26Component } from './widget26/widget26.component';
import { Timeline2Component } from './timeline2/timeline2.component';
import { LogDataTableComponent } from './general/log-data-table/log-data-table.component';
import { SaleDataTableComponent } from './general/sale-data-table/sale-data-table.component';
import { MachineAndCntComponent } from './general/machine-and-cnt/machine-and-cnt.component';
import { AreaChartComponent } from './area-chart/area-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SemiDonutComponent } from './semi-donut/semi-donut.component';
import { RadarChartComponent } from './radar-chart/radar-chart.component';
import { StackedBarComponent } from './stacked-bar/stacked-bar.component';
import { ColumnChartBasicComponent } from './column-chart-basic/column-chart-basic.component';
import { LineChartBasicComponent } from './line-chart-basic/line-chart-basic.component';

@NgModule({
	declarations: [
		DataTableComponent,
		// Widgets
		Widget1Component,
		Widget4Component,
		Widget5Component,
		Widget14Component,
		Widget26Component,
		Timeline2Component,
		LogDataTableComponent,
		SaleDataTableComponent,
		MachineAndCntComponent,
		AreaChartComponent,
		SemiDonutComponent,
		RadarChartComponent,
		StackedBarComponent,
		ColumnChartBasicComponent,
		LineChartBasicComponent,
	],
	exports: [
		AreaChartComponent,
		SemiDonutComponent,
		DataTableComponent,
		LogDataTableComponent,
		SaleDataTableComponent,
		MachineAndCntComponent,
		// Widgets
		Widget1Component,
		Widget4Component,
		Widget5Component,
		Widget14Component,
		Widget26Component,
		Timeline2Component,
		RadarChartComponent,
		StackedBarComponent,
		ColumnChartBasicComponent,
		LineChartBasicComponent
	],
	imports: [
		CommonModule,
		PerfectScrollbarModule,
		MatTableModule,
		CoreModule,
		MatIconModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatPaginatorModule,
		MatSortModule,
		NgApexchartsModule
	]
})
export class WidgetModule {
}
